module.exports = __webpack_public_path__ + "static/media/target.f086ccdb.png";